export class FloatingText {
  private container: HTMLElement;

  constructor(container: HTMLElement) {
    this.container = container;
  }

  /** Show a floating text that rises and fades out */
  show(text: string, color: string, x?: number, y?: number, size = 16): void {
    const el = document.createElement('div');
    el.className = 'floating-text';
    el.textContent = text;
    el.style.color = color;
    el.style.fontSize = `${size}px`;
    el.style.textShadow = `0 0 10px ${color}`;

    // Position: centered if no coords, otherwise at specific point
    if (x !== undefined && y !== undefined) {
      el.style.left = `${x}px`;
      el.style.top = `${y}px`;
    } else {
      el.style.left = '50%';
      el.style.top = '40%';
      el.style.transform = 'translateX(-50%)';
    }

    this.container.appendChild(el);

    // Animate: rise + fade
    requestAnimationFrame(() => {
      el.style.transform += ' translateY(-60px)';
      el.style.opacity = '0';
    });

    // Remove after animation
    setTimeout(() => el.remove(), 1200);
  }

  /** Big center combo announcement */
  showCombo(level: number): void {
    const el = document.createElement('div');
    el.className = 'floating-combo';
    el.innerHTML = `<span class="combo-num">x${level}</span> COMBO`;

    this.container.appendChild(el);

    requestAnimationFrame(() => {
      el.style.transform = 'translate(-50%, -50%) scale(1.3)';
      el.style.opacity = '0';
    });

    setTimeout(() => el.remove(), 1500);
  }

  /** Negative feedback (wrong decision) */
  showPenalty(text: string): void {
    this.show(text, '#ff6b6b', undefined, undefined, 20);
  }
}
